import { useQuery } from 'react-query';

import { applianceQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { IApplianceModel } from '../../types/Appliance/ApplianceModel';

export default function useSuperAdminApplianceModels() {
  const { get } = useApiHelper();

  const superAdminApplianceModels = useQuery({
    queryKey: applianceQueryKeys.superAdminModels(),
    queryFn: () =>
      get<IDefaultResponseWithData<IApplianceModel>>(
        `/v1/superadmin/hardware/models`
      ).then((res) => res.data.data),
  });

  return {
    superAdminApplianceModels,
  };
}
